export default "__VITE_ASSET__DHx2C_3r__"